import type { PropsWithChildren } from "react"
import React from "react"

import { GeniusChat } from "components/GeniusChat/GeniusChat"
import { blogChildrenWrapper, blogWrapper } from "./style.css"

type Props = PropsWithChildren & {
  showChat?: boolean
}

export const BlogLayout: React.FC<Props> = ({ children, showChat = false }) => {
  return (
    <>
      <div className={blogWrapper} data-testid="BlogLayout">
        <div data-testid="bloglayout-children" className={blogChildrenWrapper}>
          {children}
        </div>
      </div>
      {showChat && <GeniusChat />}
    </>
  )
}
